import { render } from "./adminbreadcrumb3.vue?vue&type=template&id=2415b33c"
import script from "./adminbreadcrumb3.vue?vue&type=script&lang=js"
export * from "./adminbreadcrumb3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__